import {createSlice} from '@reduxjs/toolkit'

const initialState = {
 data: {},
 status: 'idle',
}

const genericFormSlice = createSlice({
 name: 'genericForm',
 initialState,
 reducers: {
  setGenericFormData: (genericForm, data) => {
   genericForm.status = 'Success'
   genericForm.data = {...genericForm.data, ...data.payload}
  },
 },
})

export const {setGenericFormData} = genericFormSlice.actions

export default genericFormSlice.reducer
